import { ClipboardList } from "lucide-react";
import {
  ControlPlanParamsSchema,
  defaultControlPlanParams,
  type ControlPlanParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ControlPlanWidget } from "./Component.js";
import { ControlPlanExpandedEditor } from "./ExpandedEditor.js";

export const controlPlanDef: WidgetDef<ControlPlanParams> = {
  kind: "controlPlan",
  label: "Control Plan",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 352, h: 384 },
  defaultParams: defaultControlPlanParams,
  Component: ControlPlanWidget,
  ExpandedComponent: ControlPlanExpandedEditor,
  storage: "sql",
  schema: ControlPlanParamsSchema,
  accent: "emerald",
  icon: ClipboardList,
  subtitle: "What we monitor, who owns it, and when to act",
  defaultRoster: true,
  category: "single",
  layout: { col: 0, row: 0, width: 352, height: 360 },
  expandable: true,
  renderFooter: (data) => ({
    left: `${data.rows.length} control${data.rows.length === 1 ? "" : "s"}`,
    right: null,
  }),
};

registerWidget(controlPlanDef);
